import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4c1475cc&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "./index.vue?vue&type=style&index=0&id=4c1475cc&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1475cc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c1475cc')) {
      api.createRecord('4c1475cc', component.options)
    } else {
      api.reload('4c1475cc', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4c1475cc&scoped=true", function () {
      api.rerender('4c1475cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/features/index.vue"
export default component.exports